import DateUtil from '../utils/DateUtil';
import moment = require('moment');

export default class TSZahlungsauftragDTO {
    private _zahlungsauftragId: string;
    private _ref: string;
    private _timestampErstellt: moment.Moment | undefined;
    private _datumFaellig: moment.Moment | undefined;
    private _empfaenger: number;
    private _besitzerName: string;
    private _beitrag: number;
    private _painfileId: string;
    private _excelExportId: string;

    public get zahlungsauftragId(): string {
        return this._zahlungsauftragId;
    }

    public set zahlungsauftragId(value: string) {
        this._zahlungsauftragId = value;
    }

    public get ref(): string {
        return this._ref;
    }

    public set ref(value: string) {
        this._ref = value;
    }

    public get timestampErstellt(): moment.Moment|any {
        return this._timestampErstellt;
    }

    public set timestampErstellt(value: moment.Moment|any) {
        this._timestampErstellt = value;
    }

    public get empfaenger(): number {
        return this._empfaenger;
    }

    public set empfaenger(value: number) {
        this._empfaenger = value;
    }

    public get beitrag(): number {
        return this._beitrag;
    }

    public set beitrag(value: number) {
        this._beitrag = value;
    }

    public get besitzerName(): string {
        return this._besitzerName;
    }

    public set besitzerName(value: string) {
        this._besitzerName = value;
    }

    public get painfileId(): string {
        return this._painfileId;
    }

    public set painfileId(value: string) {
        this._painfileId = value;
    }

    public get excelExportId(): string {
        return this._excelExportId;
    }

    public set excelExportId(value: string) {
        this._excelExportId = value;
    }

    public get datumFaellig(): moment.Moment|any {
        return this._datumFaellig;
    }

    public set datumFaellig(value: moment.Moment|any) {
        this._datumFaellig = value;
    }

    deserialize(restObject: any): TSZahlungsauftragDTO {
        this.zahlungsauftragId = restObject.zahlungsauftragId;
        this.ref = restObject.ref;
        this.timestampErstellt = DateUtil.localDateTimeToMoment(restObject.timestampErstellt);
        this.datumFaellig = DateUtil.localDateToMoment(restObject.datumFaellig);
        this.empfaenger = restObject.empfaenger;
        this.besitzerName = restObject.besitzerName;
        this.beitrag = restObject.beitrag;
        this.painfileId = restObject.painfileId;
        this.excelExportId = restObject.excelExportId;
        return this;
    }

}



// WEBPACK FOOTER //
// ./src/app/models/TSZahlungsauftragDTO.ts